"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BZMODAL_ALIGNMENT_VARIANT = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _reactBootstrap = require("react-bootstrap");

var _CloseIcon = _interopRequireDefault(require("@bizzabo/icons/dist/CloseIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Header = _reactBootstrap.Modal.Header,
    Body = _reactBootstrap.Modal.Body,
    Footer = _reactBootstrap.Modal.Footer;
var BZMODAL_ALIGNMENT_VARIANT = {
  LEFT: 'left',
  CENTER: 'center'
};
exports.BZMODAL_ALIGNMENT_VARIANT = BZMODAL_ALIGNMENT_VARIANT;

var BZModal = /*#__PURE__*/function (_Component) {
  _inherits(BZModal, _Component);

  var _super = _createSuper(BZModal);

  function BZModal() {
    var _this;

    _classCallCheck(this, BZModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleOnDoneAddAnother", function (e) {
      _this.props.onHide && _this.props.onHide(e);
      _this.props.onDoneAddAnother && _this.props.onDoneAddAnother(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDone", function (e) {
      var _this$props = _this.props,
          onHide = _this$props.onHide,
          onDone = _this$props.onDone,
          doneWithoutHide = _this$props.doneWithoutHide;
      onDone === null || onDone === void 0 ? void 0 : onDone();

      if (doneWithoutHide) {
        return;
      }

      onHide === null || onHide === void 0 ? void 0 : onHide();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnCancel", function (e) {
      _this.props.onHide && _this.props.onHide(e);
      _this.props.onCancel && _this.props.onCancel(e);
    });

    return _this;
  }

  _createClass(BZModal, [{
    key: "render",
    value: function render() {
      var handleOnCancel = this.handleOnCancel,
          handleOnDone = this.handleOnDone,
          handleOnDoneAddAnother = this.handleOnDoneAddAnother,
          _this$props2 = this.props,
          _this$props2$cancelCt = _this$props2.cancelCta,
          cancelCta = _this$props2$cancelCt === void 0 ? 'Cancel' : _this$props2$cancelCt,
          danger = _this$props2.danger,
          _this$props2$doneButt = _this$props2.doneButtonCls,
          doneButtonCls = _this$props2$doneButt === void 0 ? '' : _this$props2$doneButt,
          _this$props2$cancelBu = _this$props2.cancelButtonCls,
          cancelButtonCls = _this$props2$cancelBu === void 0 ? '' : _this$props2$cancelBu,
          _this$props2$doneAddA = _this$props2.doneAddAnotherCta,
          doneAddAnotherCta = _this$props2$doneAddA === void 0 ? 'Done + Add Another' : _this$props2$doneAddA,
          _this$props2$doneAddA2 = _this$props2.doneAddAnotherLoading,
          doneAddAnotherLoading = _this$props2$doneAddA2 === void 0 ? false : _this$props2$doneAddA2,
          _this$props2$doneAddA3 = _this$props2.doneAddAnotherCls,
          doneAddAnotherCls = _this$props2$doneAddA3 === void 0 ? 'btn-info-success' : _this$props2$doneAddA3,
          _this$props2$doneCta = _this$props2.doneCta,
          doneCta = _this$props2$doneCta === void 0 ? 'Done' : _this$props2$doneCta,
          doneLoading = _this$props2.doneLoading,
          _this$props2$doneWith = _this$props2.doneWithoutHide,
          doneWithoutHide = _this$props2$doneWith === void 0 ? false : _this$props2$doneWith,
          _this$props2$disableB = _this$props2.disableBackdrop,
          disableBackdrop = _this$props2$disableB === void 0 ? false : _this$props2$disableB,
          _this$props2$disableD = _this$props2.disableDone,
          disableDone = _this$props2$disableD === void 0 ? false : _this$props2$disableD,
          hideCancel = _this$props2.hideCancel,
          _this$props2$hideDone = _this$props2.hideDone,
          hideDone = _this$props2$hideDone === void 0 ? false : _this$props2$hideDone,
          hideFooter = _this$props2.hideFooter,
          modalCls = _this$props2.modalCls,
          onDoneAddAnother = _this$props2.onDoneAddAnother,
          show = _this$props2.show,
          size = _this$props2.size,
          title = _this$props2.title,
          titleCls = _this$props2.titleCls,
          _this$props2$alignmen = _this$props2.alignment,
          alignment = _this$props2$alignmen === void 0 ? BZMODAL_ALIGNMENT_VARIANT.LEFT : _this$props2$alignmen,
          titleLink = _this$props2.titleLink,
          _this$props2$titleLin = _this$props2.titleLinkUrl,
          titleLinkUrl = _this$props2$titleLin === void 0 ? '' : _this$props2$titleLin,
          doneButtonColor = _this$props2.doneButtonColor,
          closeCls = _this$props2.closeCls,
          headerCls = _this$props2.headerCls;
      var disableDoneButtons = doneAddAnotherLoading ? true : disableDone;
      var doneLoadingButtons = doneAddAnotherLoading ? false : doneLoading;
      var footerCls = (0, _classnames2.default)({
        hide: hideFooter === true
      });
      var modalClass = (0, _classnames2.default)('bz-modal', _defineProperty({}, modalCls, modalCls));
      var buttonBsStyle = danger ? 'danger' : 'success';
      var closeIconCls = (0, _classnames2.default)('no-style-link-button', 'bz-modal-close', closeCls);
      var doneAnotherCls = (0, _classnames2.default)('btn', doneAddAnotherCls);
      var headerClass = (0, _classnames2.default)(headerCls, {
        'text-center': alignment === BZMODAL_ALIGNMENT_VARIANT.CENTER
      });
      var bodyClass = (0, _classnames2.default)({
        'text-center': alignment === BZMODAL_ALIGNMENT_VARIANT.CENTER
      });
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
        className: modalClass,
        backdrop: disableBackdrop ? 'static' : true,
        show: show,
        bsSize: size,
        onHide: handleOnCancel,
        enforceFocus: false
      }, title && /*#__PURE__*/_react.default.createElement(Header, {
        className: headerClass
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: titleCls,
        style: {
          display: 'inline-block'
        }
      }, title), titleLink && /*#__PURE__*/_react.default.createElement("a", {
        className: "bz-modal-link",
        target: "_blank",
        href: titleLinkUrl,
        rel: "noopener noreferrer"
      }, titleLink), /*#__PURE__*/_react.default.createElement("span", {
        className: closeIconCls,
        onClick: handleOnCancel
      }, /*#__PURE__*/_react.default.createElement(_CloseIcon.default, {
        width: 24,
        height: 24,
        fill: "currentColor"
      }))), /*#__PURE__*/_react.default.createElement(Body, {
        className: bodyClass
      }, this.props.children, " "), /*#__PURE__*/_react.default.createElement(Footer, {
        className: footerCls
      }, !hideCancel && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
        "aria-label": "Close",
        className: (0, _classnames2.default)('secondary', cancelButtonCls),
        onClick: handleOnCancel
      }, cancelCta), onDoneAddAnother && /*#__PURE__*/_react.default.createElement("button", {
        className: doneAnotherCls,
        disabled: disableDoneButtons,
        onClick: handleOnDoneAddAnother
      }, doneAddAnotherLoading ? /*#__PURE__*/_react.default.createElement("i", {
        className: "fa fa-spinner fa-spin"
      }) : doneAddAnotherCta), !hideDone && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
        bsStyle: buttonBsStyle,
        className: doneButtonCls,
        disabled: disableDoneButtons,
        onClick: handleOnDone,
        style: {
          backgroundColor: doneButtonColor
        }
      }, doneLoadingButtons ? /*#__PURE__*/_react.default.createElement("i", {
        className: "fa fa-spinner fa-spin"
      }) : doneCta)));
    }
  }]);

  return BZModal;
}(_react.Component);

_defineProperty(BZModal, "propTypes", {
  size: _propTypes.default.string,
  show: _propTypes.default.bool,
  disableDone: _propTypes.default.bool,
  disableBackdrop: _propTypes.default.bool,
  hideFooter: _propTypes.default.bool,
  danger: _propTypes.default.bool,
  doneLoading: _propTypes.default.bool,
  doneButtonCls: _propTypes.default.string,
  cancelButtonCls: _propTypes.default.string,
  doneWithoutHide: _propTypes.default.bool,
  cancelCta: _propTypes.default.string,
  doneCta: _propTypes.default.string,
  doneAddAnotherCta: _propTypes.default.string,
  doneAddAnotherLoading: _propTypes.default.bool,
  doneAddAnotherCls: _propTypes.default.string,
  titleCls: _propTypes.default.string,
  titleLink: _propTypes.default.string,
  titleLinkUrl: _propTypes.default.string,
  onHide: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  onDone: _propTypes.default.func,
  onDoneAddAnother: _propTypes.default.func,
  closeCls: _propTypes.default.string,
  headerCls: _propTypes.default.string,
  alignment: _propTypes.default.oneOf([BZMODAL_ALIGNMENT_VARIANT.LEFT, BZMODAL_ALIGNMENT_VARIANT.CENTERED])
});

var _default = BZModal;
exports.default = _default;